(() => { 
  const { createApp } = Vue;

  const loadCollectionProductsJSON = (url_parts, callback) => {
    let url = `/collections/${url_parts.join('/')}?view=products-json`;

    fetch(url)
      .then(res => res.text())
      .then(callback)
      .catch(console.error);
  }

  const variantsMatchingOptionValue = (optionIndex0, optionValue, variants, selected_option_values) => {
    var values_to_match = [];
    selected_option_values.forEach((v, vIndex) => {
      if (vIndex < optionIndex0) {
        values_to_match.push(v);
      }
      else if(vIndex == optionIndex0) {
        values_to_match.push(optionValue);
      }
    });

    var matching_variants = variants.filter((v) => {
      var v_options_to_match = v.options.filter((o, index) => index <= optionIndex0);
      return _.difference(v_options_to_match, values_to_match).length == 0;
    });

    var leading_variants = matching_variants.filter((v) => {
      return selected_option_values.length > 1 ? _.intersection(selected_option_values, v.options).length > 0 : true;
    });
    //console.log({optionValue, values_to_match, matching_variants, leading_variants});

    var is_sold_out = leading_variants.length && (leading_variants.filter(v => !v.available).length == leading_variants.length);
    
    return {optionValue, values_to_match, matching_variants, leading_variants, is_sold_out};
  }

  const FORM_SELECTOR = '#form-multi-variants';
  const $FORM = document.querySelector(FORM_SELECTOR);
  let $PRODUCT = document.querySelector('.page-content--product');
  const isQuickShop = $FORM.closest('[data-quickshop-product]') !== null;
  if (isQuickShop) {
    $PRODUCT = $FORM.closest('[data-quickshop-product]');
  }
  const $SELECT_NAME_ID = $PRODUCT.querySelector('[name=id]');

  createApp({
    delimiters: ['${', '}'],
    data() {
      return {
        products: [],
        CONFIG_PRODUCT: CONFIG_PRODUCT
      }
    },
    computed: {
      multi_tag() {
        return this.CONFIG_PRODUCT.multi_tag;
      },
      all_variants() {
        let vm = this;
        vm.products.forEach((p) => {
          p.variants.forEach((v) => v.product_id = p.id);
        });
        let all_variants = vm.products.map(p => p.variants).flat();
        return all_variants;
      },
      all_options_with_values() {
        let vm = this;
        let options_with_values = [];
        if (vm.products.length) {
          [1,2,3].forEach((id) => {
            let option_index0 = id - 1;
            let option = vm.products[0].options_with_values[option_index0];
            let values = [];
            vm.products.forEach((p) => {
              let p_opt_values = p.options_with_values[option_index0] ? p.options_with_values[option_index0].values : [];
              values = [].concat(values, p_opt_values);
            });
            if (values.length) {
              values = _.uniqBy(values);
              option.values = values;
              //option.values = _.sortBy(values);  // if sort by value
              options_with_values.push(option);  
            }
          });
        }

        return options_with_values;
      },
      all_options_with_values_variants() {
        let vm = this;

        let options_values = vm.all_options_with_values.map((option, optionIndex0) => {
          let isColor = ['Color', 'color'].indexOf(option.name.toLowerCase()) !== -1;
          let isSize = ['size'].indexOf(option.name.toLowerCase()) !== -1;
    
          let values_variants = option.values.map((value) => variantsMatchingOptionValue(optionIndex0, value, vm.all_variants, vm.current_variant.options));
    
          return {
            name: option.name,
            display_type: option.display_type,
            position: option.position,
            option_id: `option${option.position}`,
            isColor: isColor,
            isSize: isSize,
            values: option.values,
            values_variants: values_variants
          };
        });
        return options_values;
      },
      current_product() { 
        return this.products.find(p => p.is_selected);
      },
      current_variant() { 
        return this.current_product ? this.all_variants.find(v => v.id == this.current_product.selected_variant.id) : null;
      },
      current_variant_price() {
        let price = this.current_variant ? this.current_variant.price : 0;

        return {
          price: price || '',
          price_formatted: price ? theme.Currency.formatMoney(price) : ''
        };
      }
    },

    watch: {
      current_product() {
        // update product title
        $PRODUCT.querySelector('.product-single__title').textContent = this.current_product.title;

        // update product image
        if (isQuickShop) {
          $PRODUCT.querySelector('.QuickShop-img img').setAttribute('src', this.current_product.images[0].replace('.jpg', '_x900.jpg'));
        }
        else {
          let $imagesWrap = $PRODUCT.querySelector('[data-product-images]');
          $imagesWrap.innerHTML = '';
          $imagesWrap.insertAdjacentHTML('beforeend', this.current_product.data_product_images);
        }

        // re-init for images
        theme.sections.register('product', theme.Product);
        AOS.refreshHard();

        // update product description
        let $description = $PRODUCT.querySelector('[id*=Product-content-description] .collapsible-content__inner');
        if ($description) {
          $description.innerHTML = this.current_product.description;
        }
      },

      current_variant() { 
        let isVariantSoldout = !this.current_variant.available;
        // Add to cart button state
        let $btn_atc = $PRODUCT.querySelector('.addtocart');
        if ($btn_atc) {
          $btn_atc.classList[isVariantSoldout ? 'add' : 'remove']('disabled');
          $btn_atc.disabled = isVariantSoldout;
          $btn_atc.querySelector('[data-add-to-cart-text]').textContent = isVariantSoldout ? 'Sold Out' : 'Add To Cart';
        }

        let $btn_shop = $PRODUCT.querySelector('.shopify-payment-button');
        if ($btn_shop) {
          $btn_shop.classList[isVariantSoldout ? 'add' : 'remove']('hide');
        }

        // Update select[name=id] for add to cart
        let $select = $SELECT_NAME_ID;
        if ($select) {
          $select.value = this.current_variant.id;
        }
      }
    },

    mounted() { 
      let vm = this;

      // initial load
      vm.initProductsJSON();

      loadCollectionProductsJSON(['all', vm.multi_tag], (res) => { 
        $FORM.querySelector('[data-products-json]').insertAdjacentHTML('beforeend', res);
        vm.initProductsJSON();
        vm.updateSelectIDValues();
      });
    },

    methods: {
      initProductsJSON() { 
        let vm = this;

        $FORM.querySelectorAll('[data-product]').forEach(($product) => {
          if (!$product.querySelector('[data-product-json]')) return;
          let product = JSON.parse($product.querySelector('[data-product-json]').value);
          let options_with_values = JSON.parse($product.querySelector('[data-product-options-with-values-json]').value)
          let selected_variant = JSON.parse($product.querySelector('[data-selected-variant-json]').value);
          let size_option = options_with_values.find(option => option.name == 'Size');
          let color_option = options_with_values.find(option => option.name == 'Color');
          let data_product_images = $product.querySelector('[data-product-images]').value;

          product.options_with_values = options_with_values;
          product.selected_variant = selected_variant;
          product.size_option = size_option;
          product.color_option = color_option;
          product.data_product_images = data_product_images;

          // set is_selected if current product
          product.is_selected = vm.products.length == 0;

          // CUSTOM- Product modifications
          product.options_with_values.forEach((opt) => {
            opt.display_type = opt.name == 'Size' ? 'swatch' : 'select';
          });

          // include if not current product
          let isCurrentProduct = vm.products.find(p => p.id == product.id);
          if (!isCurrentProduct) {
            vm.products.push(product);
          }
        });
      },

      updateSelectIDValues() {
        let vm = this;
        let $select = $SELECT_NAME_ID; 
       
        // exclude current product
        let products = vm.products.filter((p, index) => index !== 0);
        products.forEach((p) => { 
          p.variants.forEach((v) => {
            $select.insertAdjacentHTML('beforeend', `<option ${!v.available ? 'disabled' : ''} value="${v.id}">${v.title}</option>`);
          });
        });
      },

      updateSelectedProduct(product) {
        this.products.forEach(p => p.is_selected = false);
        product.is_selected = true;
      },

      changeProduct(e) {
        let product_id = e.currentTarget.value;
        let product = this.products.find(p => p.id == product_id);
        if (product) {
          this.updateSelectedProduct(product);
        }
      },

      changeProductFromSwatch(e) {
        document.querySelector('.linked-color-swatches .color-swatch.selected').classList.remove('selected');

        let $swatch = e.currentTarget;
        let product_id = $swatch.dataset.product;
        let product = this.products.find(p => p.id == product_id);
        if (product) {
          $swatch.classList.add('selected');
          this.updateSelectedProduct(product);
        }
      },
      
      changeVariant(e, product) {
        let vm = this;
        let $form = e.currentTarget.closest('[data-v-product-form]');
        let $selected_values = [].concat(
          Array.from($form.querySelectorAll('input:checked')),
          Array.from($form.querySelectorAll('option:checked'))
        );
        let selected_options = $selected_values.map(($item) => $item.value);
        let variant = vm.all_variants.find(v => v.options.join('/') == selected_options.join('/'));
        product.selected_variant = variant;
      }
    }
  }).mount(FORM_SELECTOR);
})();